import { throttle } from 'lodash-es';
import detect from './detect';
let cache = {};
let history = {};
let root;
let ignoreScrollResize = true;
const dimensions = () => {
    if (cache.dimensions)
        return cache.dimensions;
    const dimensions = {
        width: !root ? window.innerWidth : Math.floor(root.getBoundingClientRect().width),
        innerWidth: document.body.getBoundingClientRect().width,
        // height: Math.min(document.documentElement.offsetHeight, window.innerHeight)
        height: window.innerHeight
    };
    dimensions.innerHeight = dimensions.height;
    dimensions.scrollWidth = dimensions.width - dimensions.innerWidth;
    // Ignore ios resize on scroll (wheen bottom bar disappear)
    if (ignoreScrollResize &&
        detect.iphone &&
        history.dimensions &&
        history.dimensions.width === dimensions.width)
        dimensions.innerHeight = history.dimensions.innerHeight;
    dimensions.ratio = dimensions.width / dimensions.height;
    history.dimensions = Object.assign({}, dimensions);
    return (cache.dimensions = dimensions);
};
const width = () => dimensions().width;
const height = () => dimensions().height;
const ratio = () => dimensions().ratio;
const scrollWidth = () => dimensions().scrollWidth;
const testMQ = (mq) => () => cache[mq] || (cache[mq] = window.matchMedia(mq).matches);
const clear = () => {
    history = cache;
    cache = {};
};
let listeners = [];
const resize = (event) => {
    _resize(event);
};
const _resize = throttle((event) => {
    clear();
    listeners.forEach((listener) => listener && listener.resize && listener.resize());
}, 50);
window.addEventListener('resize', resize);
window.addEventListener('orientationchange', resize);
const add = (listener) => listeners.push(listener);
const remove = (listener) => (listeners = listeners.filter(item => item !== listener));
const setRoot = (r) => {
    root = r;
    clear();
    resize();
};
const setIgnoreScrollResize = (i) => (ignoreScrollResize = !!i);
export { dimensions };
export default {
    dimensions,
    scrollWidth,
    outerWidth,
    ratio,
    width,
    height,
    clear,
    add,
    remove,
    setRoot,
    setIgnoreScrollResize,
    resize,
    testMQ
};
